import { Modal } from '@wajeez-web/components/ui';
import { CommonModalProps } from '@wajeez-web/components/modals';
import { useCustomerSelector } from '@wajeez-web/stores/customers';
import { getMonthName } from '@wajeez-web/core/utils';
import { NoData } from '@wajeez-web/components/ui';
import { ReturnTranslatedText } from '@wajeez-web/core/localization';
export const UserDevicesModal = ({
  onClose,
  isOpen,
}: CommonModalProps<unknown>) => {
  const { userDevices } = useCustomerSelector((s) => s.usersAnalytics);

  return (
    <Modal
      title="User Devices"
      onClose={onClose}
      open={isOpen}
      withScroll={true}
    >
      <div className="text-center">
        <div className="grid grid-cols-6 py-2 gap-4 ">
          <div className="col-span-2">
            <div className="text-[#727783] text-[14px] font-semibold">
              <ReturnTranslatedText text={'tables.columnTitles.Device Maker'} />
            </div>
          </div>
          <div className="col-span-2">
            <div className="text-[#727783] text-[14px] font-semibold">
              <ReturnTranslatedText text={'tables.columnTitles.ModelName'} />
            </div>
          </div>
          <div className="col-span-2">
            <div className="text-[#727783] text-[14px] font-semibold">
              <ReturnTranslatedText
                text={'tables.columnTitles.ApplicationVersion'}
              />
            </div>
          </div>
        </div>
        {userDevices.length === 0 && (
          <div className="mt-4">
            {' '}
            <NoData />
          </div>
        )}
        {userDevices?.map((device, index: number) => {
          return (
            <div className="grid grid-cols-6 py-2 gap-4 " key={index}>
              <div className="col-span-2">
                <div className="text-[#727783] text-[14px] font-normal">
                  {device.deviceMaker}
                </div>
              </div>
              <div className="col-span-2">
                <div className="text-[#727783] text-[14px] font-normal">
                  {device.modelName}
                </div>
              </div>
              <div className="col-span-2">
                <div className="text-[#727783] text-[14px] font-normal">
                  {device.applicationVersion}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </Modal>
  );
};

export default UserDevicesModal;
